import { FC, useEffect, useState } from 'react';
import { Button, Modal } from '@marriott/mi-ui-library';
import { SignInModalProps } from './SignInModal.types';
import { StyledSignInModal } from './SignInModal.styles';
import clsx from 'clsx';
import { useCreateSurveyStore } from '../../store/createSurveyStore';
import { SignInForm } from '../SignInForm';
import { mockSignInFormProps, signInErrorMessages } from './__mock__/__mock__';
import { usePathname, useRouter } from 'next/navigation';
import { updateDatalayer } from '../../util/dataLayer/datalayerUtil';

export const SignInModal: FC<SignInModalProps> = (props: SignInModalProps) => {
  const { formData, setFormData } = useCreateSurveyStore(); // Access formData from Zustand store
  const { show, onClose, modalData } = props;
  const [showModal, setShowModal] = useState<boolean>(show);
  const marshaCode = formData?.marshaCode;

  const pathName = usePathname();
  const router = useRouter();
  const handleNextPage = (newPart?: string) => {
    const currentPath = pathName;
    const newPath = currentPath.replace(/\/[^/]*$/, `/${newPart}`);
    // handleRedirect(newPath);
    router.push(newPath);
  };
  const onCloseModal = () => {
    setShowModal(false);
    setFormData({ ...formData, isSignInDrawerOpen: false });
    if (formData?.isSubmitDataFlow && !formData?.isUserEnableSignIn && formData?.consentCheckbox) {
      updateDatalayer('form_step_name', 'Thank You');
      handleNextPage('thank-you.mi');
      setFormData({
        ...formData,
        isCloseSignInModalOnSubmit: true,
      });
    }
    onClose?.();
  };

  useEffect(() => {
    // Run only when modal actually closes
    if (!showModal && formData?.isReviewPageFlow) {
      setFormData({ ...formData, isReviewPageFlow: false });
    }
  }, [showModal]);

  useEffect(() => {
    setShowModal(show);
  }, [show]);
  const signInLabels = props?.modalData;
  const membershipHeading = signInLabels?.membershipHeading ?? 'Not a member? Join Now';
  const continueasguest = signInLabels?.continueasguest ?? 'Continue As Guest';
  const membershipBenefits = signInLabels?.membershipBenefits || [
    'Enjoy our lowest rates, all the time',
    'Free in room WIi-Fi',
    'Mobile check in and more',
  ];
  const guestLinkText = ' Join and Continue';
  const guestLink = 'https://www.joinmarriottbonvoy.com/';

  return (
    <StyledSignInModal data-component-name="m-prearrival-SignInModal" data-testid="prearrival-SignInModal">
      <Modal
        modalId="signInModal"
        role="dialog"
        labelledBy="signInModal"
        secondaryClassName="sign-in-modal"
        show={showModal}
        popupOpenState={showModal}
        handleBlur={true}
        disableScrollOnBody={true}
        // setPopupOpenState={onCloseModal}
        onClose={onCloseModal}
      >
        <Modal.Header labelText="" popupHeaderOnCLoseFunc={onCloseModal} className="row  modal-header" />

        <Modal.Body className="modal-body">
          <div className="modal-content ">
            {/* LEFT: Join Block */}
            <div className="join-now-block">
              <div className="logo-container  px-0 mt-2  pb-2">
                <div className={clsx('t-program-logo-color-s', 'logo')} aria-label="Marriott Bonvoy" />
              </div>
              <h3>{membershipHeading}</h3>
              <ul className="benefits">
                {membershipBenefits.map((label: string, idx: number) => (
                  <li key={idx}>{label}</li>
                ))}
              </ul>

              <div className="join-guest ">
                <Button
                  isLink={true}
                  buttonCopy={guestLinkText}
                  href={`${guestLink}${marshaCode}`}
                  className="join-guest-btn join-guest-mobile border-color m-button-m m-button-secondary text-center width-mobile-100 d-flex-sm justify-content-center align-items-center px-5 custom_click_track"
                />
              </div>
              <hr />
              <div className="continue-guest">
                <div className=" col-12 footer-container pt-2 d-flex align-items-center px-0 ">
                  <span className="t-font-xs pr-1">Or</span>
                  <a onClick={onCloseModal} className="t-label-alt-s continue-container" tabIndex={0}>
                    {continueasguest}
                    <span className="icon-forward-arrow-cropped pl-2 continue-container__link--tertiary" />
                  </a>
                </div>
              </div>
            </div>

            {/* RIGHT: Sign In Form */}
            <div className="sign-in-block">
              <SignInForm
                {...mockSignInFormProps}
                onClose={onCloseModal}
                modalData={modalData}
                isOpen={showModal}
                isFlyOut={true}
                signInErrorMessages={signInErrorMessages}
              />
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </StyledSignInModal>
  );
};
